const TurnaLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 157 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M67.679 6.129V18.98c0 3.916 1.373 7.368 5.81 7.368 4.438 0 5.765-3.523 5.765-7.368V6.13h5.811v12.899c0 4.436-1.458 8.883-5.765 10.89q-2.242 1.019-5.81 1.019-3.57 0-5.858-1.02c-4.326-2.056-5.765-6.42-5.765-10.89V6.13zM59.101 30.38c-1.519.29-3.077.551-4.626.551-2.449 0-4.98-.619-6.524-2.661-1.46-2.029-1.712-4.64-1.712-7.068V10.601h-3.84V6.122h3.84V0h5.876v6.122h6.338v4.48h-6.338v10.555c0 1.696-.145 3.844 1.341 5.002 1.492 1.163 3.96.289 5.645-.046v4.268M102.492 6.324c-1.062-.06-2.125-.14-3.19-.14-2.889 0-6.115.346-8.432 2.239-2.699 2.189-3.226 5.925-3.226 9.184V30.31h5.807V17.653c0-2.013.127-4.463 1.704-5.94 1.203-1.127 2.936-1.325 4.516-1.325.941 0 1.881.078 2.82.134V6.324zM116.978 5.6c-2.952.197-4.996 2.07-6.027 3.654V6.127h-5.81l.001 24.19h5.888V17.602c0-.924.483-3.834 1.781-5.132 1.102-1.343 2.656-2.204 4.425-2.215 2.703.09 4.703 1.721 5.246 4.342q.279 1.34.279 3.005v12.717h5.888V17.554q0-2.22-.51-4.346c-.498-2.284-1.814-4.368-3.786-5.648-1.774-1.226-4.161-2.174-7.374-1.96zM11.618 7.836c-.571-1.674-1.722-3.178-3.408-3.7L0 1.6l2.065 7.02a11.46 11.46 0 0 0 9.761 8.178 11.47 11.47 0 0 0-9.76 8.182L0 32l8.21-2.538c1.686-.521 2.837-2.025 3.409-3.7 1.77-5.18 6.662-8.914 12.432-8.962-5.776-.043-10.664-3.78-12.433-8.964"
    ></path>
    <path
      fill="currentColor"
      d="M29.966 7.836c-.571-1.674-1.722-3.178-3.409-3.7L18.347 1.6l2.066 7.02a11.46 11.46 0 0 0 9.761 8.178 11.47 11.47 0 0 0-9.761 8.182L18.348 32l8.21-2.538c1.686-.521 2.837-2.025 3.409-3.7 1.77-5.18 6.661-8.914 12.432-8.962-5.776-.043-10.664-3.78-12.433-8.964M143.465 26.32c4.339 0 7.106-4.316 7.106-8.3 0-3.986-2.78-7.927-7.106-7.927s-6.831 3.87-6.831 7.785 2.392 8.442 6.831 8.442m7.151.235c-1.582 2.74-4.341 4.243-7.472 4.361q-2.797.14-5.089-.797c-3.055-1.34-5.254-3.891-6.418-6.988q-.871-2.44-.871-5.206c0-3.498 1.232-6.862 3.805-9.287 2.471-2.269 5.843-3.376 9.169-3.376 3.155 0 6.324 1.17 8.71 3.236 2.466 2.07 3.989 5.116 3.989 8.348v13.47h-5.823z"
    ></path>
  </svg>
);

const TurnaLogoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={28}
    viewBox="0 0 38 28"
    fill="none"
    {...props}
  >
    <path
      d="M10.166 6.85747C9.66612 5.39243 8.659 4.07643 7.18346 3.62056L0 1.40039L1.80717 7.5426C2.95954 11.46 6.32217 14.2527 10.348 14.6992C6.3035 15.1493 2.95312 17.9636 1.80717 21.8585L0 28.0004L7.18317 25.7802C8.659 25.3241 9.66612 24.0081 10.1666 22.5433C11.7157 18.0105 15.9956 14.7427 21.0446 14.7007C15.9909 14.6633 11.7139 11.3935 10.166 6.85747Z"
      fill="#01007F"
    />
    <path
      d="M26.2207 6.85747C25.7208 5.39243 24.714 4.07643 23.2381 3.62056L16.0547 1.40039L17.8619 7.5426C19.0142 11.46 22.3769 14.2527 26.4027 14.6992C22.3582 15.1493 19.0078 17.9636 17.8619 21.8585L16.0547 28.0004L23.2381 25.7802C24.7137 25.3241 25.7208 24.0081 26.2213 22.5433C27.7704 18.0105 32.0503 14.7427 37.0993 14.7007C32.0456 14.6633 27.7686 11.3935 26.2207 6.85747Z"
      fill="#01007F"
    />
  </svg>
);

export { TurnaLogoIcon };
export default TurnaLogo;
